import React from 'react';
import {withRouteData, Head} from 'react-static';
import Markdown from '../../lib/Markdown';
import styles from './style.scss';

export default withRouteData(function About({page}) {
  return (
    <div className={styles.root}>
      <Head>
        <title>{page.title}</title>
      </Head>
      <Markdown className={styles.content} source={page.content} />
      <div className={styles.photo}>{page.photo && <img src={page.photo} alt={page.title} />}</div>
    </div>
  );
});
